import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthProvider";

// Allows admin OR editor — anyone with portal access.
const RequireAdmin = ({ children }: { children: React.ReactNode }) => {
  const { user, isEditor, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (!isEditor) {
    return <Navigate to="/admin/not-authorized" replace />;
  }

  return <>{children}</>;
};

export default RequireAdmin;
